"use strict";import{TableCell as e}from"./src/TableCell.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-table-cell",e);
//# sourceMappingURL=sp-table-cell.js.map
